import React from "react";
import { Modal, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FiAlertTriangle, FiEye, FiX } from "react-icons/fi";

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  onView,
  confirmText = "Confirm",
  viewText = "View Details",
  variant = "warning",
  size = "md",
  loading,
}) => {
  const variantColors = {
    danger: {
      bg: "bg-danger-subtle",
      text: "text-danger",
      button: "btn-danger",
    },
    warning: {
      bg: "bg-warning-subtle",
      text: "text-warning",
      button: "btn-warning",
    },
    info: {
      bg: "bg-info-subtle",
      text: "text-info",
      button: "btn-info",
    },
    success: {
      bg: "bg-success-subtle",
      text: "text-success",
      button: "btn-success",
    },
  };

  const colors = variantColors[variant] || variantColors.warning;

  return (
    <Modal show={show} onHide={onHide} centered size={size} backdrop="static">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
      >
        <Modal.Header
          className={` position-relative boder border-bottom-0`}
          style={{ borderLeft: `3px solid ${colors.bg}` }}
        >
          <div className="d-flex align-items-center gap-2">
            <FiAlertTriangle className={`${colors.text}`} size={24} />
            <Modal.Title className={`${colors.text} mb-0`}>{title}</Modal.Title>
          </div>
          <button
            onClick={onHide}
            className="btn btn-sm position-absolute end-0 top-0 m-2"
            disabled={loading}
          >
            <FiX size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="py-3">
          <p className="mb-0 text-secondary">{message}</p>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <Button
              variant="outline-secondary"
              onClick={onView}
              className="d-flex align-items-center gap-2"
              disabled={loading}
            >
              <FiEye size={18} />
              {viewText}
            </Button>
          </motion.div>
     
          <div className="flex-grow-1"></div>

          <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <Button
              variant={variant}
              onClick={onConfirm}
              className={colors.button}
              disabled={loading}
            >
              {loading ? "loading..." : confirmText}
            </Button>
          </motion.div>
        </Modal.Footer>
      </motion.div>
    </Modal>
  );
};

export default ConfirmationModal;
